export class ApiError extends Error
{
    private code: number;
    
    constructor(code: number, message: string)
    {
        super(message);
        this.code = code;
    }
}

export class Api
{
    public token: string;

    protected cfg: { baseUrl: string };

    constructor(configuration: { baseUrl: string }) {
        this.cfg = configuration;
    }

    public async get<T>(url: string): Promise<T>
    {
        let fullUrl = this.buildUrl(url);
        let resp: Response = await fetch(fullUrl, {
            method: 'GET',
            mode: 'cors',
            headers: this.buildHeaders(),
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            cache: 'no-cache',
            credentials: 'include',
        }) as any;

        let json: T = await resp.json();
        if((json as any).error) {
            throw new ApiError((json as any).error.code, (json as any).error.message);
        }

        return json;
    }

    public async post<T>(url: string, data: any): Promise<T>
    {
        let fullUrl = this.buildUrl(url);
        let resp: Response = await fetch(fullUrl, {
            method: 'POST',
            mode: 'cors',
            headers: this.buildHeaders(),
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            cache: 'no-cache',
            credentials: 'include',
            body: JSON.stringify(data)
        }) as any;
        
        let json: T = await resp.json();
        if((json as any).error) {
            throw new ApiError((json as any).error.code, (json as any).error.message);
        }

        return json;
    }

    private buildHeaders(): Headers
    {
        let headers: any = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        if(this.token) {
            headers.Authorization = 'Bearer ' + this.token;
        }
        return new Headers(headers);
    }

    private buildUrl(url: string): string {
        if(this.cfg.baseUrl.substr(0, 4) === 'http') {
            return this.cfg.baseUrl + url;
        }
        else {
            return location.origin + this.cfg.baseUrl + url;
        }
    }

}